// @ts-nocheck
import KitchenSidebar, { KitchenMobileNav } from "./KitchenSidebar";
import AutoTranslateScope from "./AutoTranslateScope";
import "./KitchenShell.css";
import "./KitchenModuleShell.css";

export default function KitchenModuleShell({
  activeModule,
  bedrijfsnaam,
  logoUrl,
  weatherPlace,
  onNavigate,
  children,
  language,
}) {
  const nav = (moduleId) => {
    if (moduleId === "mep") return onNavigate?.("mep", "lijst");
    if (moduleId === "recepten") return onNavigate?.("recepten", "recepten");
    if (moduleId === "team") return onNavigate?.("team", "medewerkers");
    return onNavigate?.(moduleId, null);
  };

  return (
    <div className="kc-shell kc-shell--module">
      <KitchenSidebar
        activeModule={activeModule}
        onNavigate={nav}
        bedrijfsnaam={bedrijfsnaam}
        logoUrl={logoUrl}
        weatherPlace={weatherPlace}
      />
      <div className="kc-module-stage">
        {language?.languages?.length > 0 && (
          <div className="kc-module-language">
            <select
              value={language.lang || "nl"}
              onChange={(e) => language.onChange?.(e.target.value)}
              aria-label={language.label || "Taal"}
              title={language.label || "Taal"}
            >
              {language.languages.map((l) => <option key={l.code} value={l.code}>{l.label}</option>)}
            </select>
          </div>
        )}
        <AutoTranslateScope>{children}</AutoTranslateScope>
      </div>
      <KitchenMobileNav activeModule={activeModule} onNavigate={nav} />
    </div>
  );
}
